import { isEmpty } from 'lodash'
import moment from 'moment'
import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const ViewQuery = ({ show, handleClose, inquiryInfo }) => {


    return (
        <Modal isOpen={show} toggle={handleClose} size='md'>
            <ModalHeader tag="h4" toggle={handleClose}>
                {!isEmpty(inquiryInfo) ? "Audit Logs" : "Edit Query"}
            </ModalHeader>
            <ModalBody>
                {!isEmpty(inquiryInfo) ? (
                    <div>
                        <div>
                            <ul className="verti-timeline list-unstyled">
                                <li className="event-list">
                                    <div className="event-timeline-dot">
                                        <i
                                            className={

                                                "bx bx-right-arrow-circle"
                                            }
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <div className="me-3">
                                            <i
                                                className={
                                                    "bx bx-edit" + " h2 text-primary"
                                                }
                                            />
                                        </div>
                                        <div className="flex-grow-1">
                                            <div>
                                                <p style={{ fontWeight: "600", fontSize: "14px" }}>Query Created</p>
                                                <p>
                                                Query created by {inquiryInfo.user?.firstName} {" "} {inquiryInfo?.user?.lastName} on {moment(inquiryInfo.createdAt).format('MMM DD, YYYY')} at {moment(inquiryInfo.createdAt).format("hh:mm A")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                {inquiryInfo?.productStatus == 'pending' && <li className="event-list"><div className="d-flex mb-3" >
                                    <div className="event-timeline-dot">
                                        <i
                                            className={
                                                inquiryInfo?.productStatus == 'pending' && inquiryInfo?.productInquiryRemarks?.length == 0
                                                    ? "bx bx-right-arrow-circle bx-fade-right"
                                                    : "bx bx-right-arrow-circle"
                                            }
                                        />
                                    </div>
                                    <div className="me-3">
                                        <i
                                            className={
                                                "bx bx-badge-check" + " h2 text-primary"
                                            }
                                        />
                                    </div>
                                    <div >
                                        <p style={{ fontWeight: "600", fontSize: "14px" }}>
                                        Query is pending
                                        </p>
                                        <p>
                                            {inquiryInfo?.productStatus == 'pending' ? 'Query Pending' : ''}
                                        </p>
                                    </div>
                                </div></li>}
                                
                                    {inquiryInfo?.productInquiryRemarks?.length ? (
                                        inquiryInfo?.productInquiryRemarks?.map((remark, index) => (
                                            <li className="event-list"  key={remark.id}><div className="d-flex mb-3">
                                                <div className="event-timeline-dot">
                                                    <i
                                                        className={
                                                            inquiryInfo?.productStatus == 'pending' && inquiryInfo?.productInquiryRemarks?.length == index + 1
                                                                ? "bx bx-right-arrow-circle bx-fade-right"
                                                                : "bx bx-right-arrow-circle"
                                                        }
                                                    />
                                                </div>
                                                <div className="me-3">
                                                    <i
                                                        className={
                                                            "bx bx-badge-check" + " h2 text-primary"
                                                        }
                                                    />
                                                </div>
                                                <div >
                                                    <p style={{ fontWeight: "600", fontSize: "14px" }}>Remarks Added</p>
                                                    <p>
                                                        Remarks by {remark?.user?.firstName} {" "} {remark?.user?.lastName} at {moment(remark.createdAt).format('MMM DD, YYYY') + ' ' + moment(remark.createdAt).format('hh:mm A')}
                                                    </p>
                                                </div>
                                            </div>
                                            </li>

                                        ))
                                    ) : ''}
                                
                                {inquiryInfo?.productStatus != 'pending' && <li className="event-list"><div className="d-flex mb-3" >
                                    <div className="event-timeline-dot">
                                        <i
                                            className={
                                                true
                                                    ? "bx bx-right-arrow-circle bx-fade-right"
                                                    : "bx bx-right-arrow-circle"
                                            }
                                        />
                                    </div>
                                    <div className="me-3">
                                        <i
                                            className={
                                                "bx bx-badge-check" + " h2 text-primary"
                                            }
                                        />
                                    </div>
                                    <div >
                                        <p style={{ fontWeight: "600", fontSize: "14px" }}>
                                            Inquiry {inquiryInfo?.productStatus == 'win' ? 'won' : 'lost'}
                                        </p>
                                        <p>
                                            {inquiryInfo?.productStatus == 'win' ? 'Query Won' : 'Query Lost'} by {inquiryInfo?.updatedByUser?.firstName} {inquiryInfo?.updatedByUser?.lastName} on {moment(inquiryInfo.updatedAt).format(" MMM DD, YYYY")} at {moment(inquiryInfo.updatedAt).format("hh:mm A")}
                                        </p>
                                    </div>
                                </div></li>}

                            </ul>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </ModalBody>
        </Modal>
    )
}

export default ViewQuery